import React, { useState } from "react";
import "../Stylesheets/main.css";
import Autosuggest from "react-autosuggest";
import { useRef } from "react";

// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

export default function AutoSuggestBox({handleSuburbChange, setDeliveryAddress, persistValues, deliveryAddress}) {
    const [propertySuggestions, setPropertySuggestions] = useState([]); 
    const [propertyAddress, setPropertyAddress] = useState(deliveryAddress);
    const timeoutRef = useRef(null);

    // Set variables from autosuggest on Property Address to autocomplete PropertyAddress, Suburb and PostCode
    function SetPropertyAddressDetails(value) {
        var newValue = value.address;

        persistValues();
        handleSuburbChange(value.suburb);
        setDeliveryAddress(value.address);

        // Return this value 
        return newValue;
    }

    // Use AutoSuggest api from Wastetrack layer of ARCGIS, displayed only Maitland LGA Address
    function AutoSuggestFunction(value) {
        setTimeout(function(){

            if(value && value.length > 4) {
                fetch(baseUrl + "wastetrack/search-bin?addressText=" + value, {
                    method: "GET"
                })
                .then(response => response.json())
                .then(response => {   
                    const theseSuggestions = [];
                    var count = 0;
                    response.forEach(function(thisSuggestion) {
                        theseSuggestions[count] = thisSuggestion;
                        count++;
                    })

                    setPropertySuggestions(theseSuggestions.map(row => ({
                        address: (row.unit_number ? `${row.unit_number}/` : "") + row.street_number + " " + row.street_name + ", " + row.suburb + ", " + row.postcode,
                        suburb: row.suburb
                    })));
                })
                .catch(error => console.log(error));
            }
        }, 200);
    }

    function handleAddressChange(value) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setPropertyAddress(value);

        timeoutRef.current = setTimeout(() => AutoSuggestFunction(value), 500);
    };

    return (
    <Autosuggest
        inputProps={{
            autoComplete: "abcd",
            name: "propertyAddress",
            id: "propertyAddress",
            value: propertyAddress,
            onChange:(_event, { newValue }) => {
                handleAddressChange(newValue);
            },
            style: {fontWeight: '400'}
        }}
        suggestions={propertySuggestions}
        onSuggestionsFetchRequested={async ({ value }) => {
            if (!value) {
                setPropertySuggestions([]);
                return;
            }
        }}
        onSuggestionsClearRequested={() => {
            setPropertySuggestions([]);
        }}
        getSuggestionValue={suggestion => SetPropertyAddressDetails(suggestion)}
        renderSuggestion={suggestion => <div className="binSuggestion">
            {suggestion.address}
        </div>}
    />)
}